module.exports = __webpack_public_path__ + "img/Postnatal Multivitamin.185952bd.jpg";